<base-support-modal [title]="title" [btnOkClass]="pro ? 'btn-danger' : 'btn-success'" [btnOkLabel]="(pro ? 'Убрать' : 'adminstat.support.support.appoint') | translate"  (onOk)="ok()" >
	<p *ngIf="!pro">Вы уверены, что хотите назначить PRO для этого пользователя?</p>
	<p *ngIf="pro">Вы уверены, что хотите убрать PRO для этого пользователя?</p>
</base-support-modal>
